import React from 'react';
import { useTranslation } from 'react-i18next';

const Verification: React.FC = () => {
  const { t } = useTranslation('common');
  const websiteTitle = import.meta.env.VITE_WEB_TITLE ?? 'Aitomistic Hub';
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-[#1E1E1E] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white dark:bg-[#252526] shadow-lg rounded-lg p-8">
          {/* Header */}
          <h1 className="text-3xl font-bold text-gray-900 dark:text-[#CCCCCC] mb-8 text-center">
            {t('verification.title', { title: websiteTitle })}
          </h1>
          
          {/* Main Content */}
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-700 dark:text-[#CCCCCC] leading-relaxed mb-6">
              To ensure a secure and fair use of resources, <strong>newly registered users have limited access</strong> to certain advanced features of Aitomistic Hub.
            </p>
            
            <p className="text-lg text-gray-700 dark:text-[#CCCCCC] leading-relaxed mb-8">
              Aitomistic Hub is designed for <strong>AI-powered atomistic simulations</strong>. Some tools — such as the <strong>web terminal, Python script submission, and Jupyter Lab</strong> — are powerful but could be misused for activities outside the platform's intended scope. To prevent misuse and ensure resources are focused on research and learning in atomistic simulations, these features are available <strong>only to verified users</strong>.
            </p>
            
            {/* Divider */}
            <hr className="border-gray-300 dark:border-[#404040] my-8" />
            
            {/* Verification Section */}
            <h2 className="text-2xl font-semibold text-gray-900 dark:text-[#CCCCCC] mb-6">
              {t('verification.how_title')}
            </h2>
            
            <div className="space-y-6">
              {/* Automatic verification */}
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-blue-500 dark:bg-[#0E639C] rounded-full mt-3 flex-shrink-0"></div>
                <div>
                  <strong className="text-gray-900 dark:text-[#CCCCCC]">{t('verification.auto_title')}</strong>{t('verification.auto_desc')}
                </div>
              </div>
              
              {/* Premium users */}
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-blue-500 dark:bg-[#0E639C] rounded-full mt-3 flex-shrink-0"></div>
                <div>
                  <strong className="text-gray-900 dark:text-[#CCCCCC]">{t('verification.premium_title')}</strong>{t('verification.premium_desc')}
                </div>
              </div>
              
              {/* Expedited verification */}
              <div className="flex items-start space-x-3">
                <div className="w-2 h-2 bg-blue-500 dark:bg-[#0E639C] rounded-full mt-3 flex-shrink-0"></div>
                <div>
                  <strong className="text-gray-900 dark:text-[#CCCCCC]">{t('verification.expedited_title')}</strong>{t('verification.expedited_prefix')}{' '}
                  <a 
                    href="mailto:contact@aitomistic.com" 
                    className="text-blue-600 dark:text-[#3794DE] hover:text-blue-800 font-medium underline"
                  >
                    {t('verification.expedited_email')}
                  </a>{t('verification.expedited_suffix')}
                </div>
              </div>
            </div>
            
            {/* Divider */}
            <hr className="border-gray-300 dark:border-[#404040] my-8" />
            
            {/* Bottom Message */}
            <div className="bg-blue-50 dark:bg-[#1E3A5F] border-l-4 border-blue-400 dark:border-[#0E639C] p-4 rounded-r-lg">
              <div className="flex items-start">
                <div className="text-blue-600 dark:text-[#3794DE] text-xl mr-3">👉</div>
                <p className="text-blue-900 dark:text-[#CCCCCC] font-medium">
                  {t('verification.note')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verification;
